<template>
  <div class="brand-wallpaper">
    <Heading
      class="brand-wallpaper__heading"
      tag="h2"
      size="md"
      font-weight="regular"
      spaces-bottom
      >Top Marken</Heading
    >
    <div class="brand-wallpaper__image-section">
      <template
        v-for="(brand, index) in brandsWithLogo"
        :key="index"
      >
        <LinkButton
          tag="nuxt-link"
          class="brand-wallpaper__tile"
          :to="brand.link || `/zubehoer/_${brand.slug}`"
          no-styling
        >
          <CdnImage
            :src="brand.logo"
            :alt="`${brand.name} Logo`"
            class="brand-wallpaper__logo filter-invert"
            :image-style="`aspect-ratio: ${brand.aspectRatio}`"
            lazy
            render-without-figure
          />
        </LinkButton>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Heading, LinkButton } from '@i22team/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';
import { addLogo, type BrandWithLogo, type LogoBrand } from '~/lib/brand';

defineComponent({ name: 'BrandWallpaper' });

const brands: LogoBrand[] = [
  {
    name: 'Apple',
    slug: 'apple',
  },
  {
    name: 'Samsung',
    slug: 'samsung',
  },
  {
    name: 'Xiaomi',
    slug: 'xiaomi',
  },
  {
    name: 'Google',
    slug: 'google',
  },
  {
    name: 'Nothing',
    slug: 'nothing',
  },
  {
    name: 'dbramante1928',
    slug: 'dbramante1928',
  },
  {
    name: 'Anker',
    slug: 'anker',
  },
  {
    name: 'Fairphone',
    slug: 'fairphone',
  },
  {
    name: 'Teufel',
    slug: 'teufel',
  },
  {
    name: 'A-good',
    slug: 'agood',
  },
  {
    name: 'Displex',
    slug: 'displex',
  },
  {
    name: 'Panzerglass',
    slug: 'panzerglass',
  },
];

const brandsWithLogo: BrandWithLogo[] = brands
  .map((brand) => addLogo(brand))
  .filter((b) => !!b?.logo);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.brand-wallpaper {
  padding-inline: $grid-base;

  &__image-section {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: calc($grid-base / 2);
    align-self: center;

    @include mq(false, $mq-sm - 1) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__tile {
    overflow: hidden;
    background-color: var(--color-gray-200);
    aspect-ratio: 249 / 139;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &:hover {
      background-color: var(--color-gray-200);
      .brand-wallpaper__logo {
        transform: scale(1.05);
      }
    }
  }

  &__logo {
    height: 35px;
    max-width: 80%;
    object-fit: contain;
    max-height: 100%;
    transition: transform 0.3s;
  }
}
</style>
